module.exports = __webpack_public_path__ + "media/images/carta-preliminar-5cf714534c1e84ee39b810e4d70eea40.png";